import React from 'react';
import Link from 'next/link';
import { routes } from 'env/routes';
import { useTranslation } from 'react-i18next';

import { inject, observer } from 'mobx-react';
import withCustomComponent from 'ui/components/withCustomComponent';
import { withRouter } from 'next/router';

export const CheckoutComplete = withCustomComponent('CheckoutComplete')(
  inject('authStore')(
    withRouter(
      observer(({ authStore, componentName }) => {
        const { t } = useTranslation();
        const { customer } = authStore;

        return (
          <div
            data-component-name={componentName}
            className="mt-32"
          >
            <div className="border-dashed rounded p-24 p-lg-48 pb-32 pb-lg-64 text-center">

              <svg width="68px" height="68px" viewBox="0 0 68 68" version="1.1" xmlns="http://www.w3.org/2000/svg">
                <g id="Icons/Large/Empty-Basket" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
                  <g id="Group" transform="translate(6.800000, 6.800000)" stroke="#999999" strokeWidth="3">
                    <g transform="translate(0.000000, 0.000000)" id="Path">
                      <line x1="33.3653335" y1="0.090666667" x2="42.3111113" y2="15.0204445"></line>
                      <line x1="21.0346668" y1="0.090666667" x2="12.0888889" y2="15.0204445"></line>
                      <path d="M50.6464002,27.2000001 L45.5479113,50.7400891 C45.0976002,52.8254224 43.2510224,54.3123558 41.1173335,54.3123558 L13.2826667,54.3123558 C11.1489778,54.3123558 9.30542226,52.8254224 8.85208893,50.7400891 L3.75360002,27.2000001"></path>
                      <path d="M51.377778,27.2000001 L3.02222223,27.2000001 C1.35395556,27.2000001 0,25.8460446 0,24.1777779 L0,18.1333334 C0,16.4650667 1.35395556,15.1111112 3.02222223,15.1111112 L51.377778,15.1111112 C53.0460447,15.1111112 54.4000002,16.4650667 54.4000002,18.1333334 L54.4000002,24.1777779 C54.4000002,25.8460446 53.0460447,27.2000001 51.377778,27.2000001 Z" fill="#CCCCCC"></path>
                      <polyline points="34 36.55 25.4982288 45.05 20.4 39.95"></polyline>
                    </g>
                  </g>
                </g>
              </svg>

              <h4 className="my-12">{t('Thank you. You are all done!')}</h4>

              {!customer?.Active && (
                <p className="fs-14 text-gray-700 mxw-400px mx-auto">
                  {t('We will review your account and get in touch shortly.')}
                </p>
              )}

              <div className="d-inline-flex justify-content-center mt-12">
                <Link href={routes.profile}>
                  <a className="btn btn-icon btn-outline">
                    <i className="icon-user-circle"></i>
                    {t('Access your account')}
                  </a>
                </Link>
              </div>


            </div>
          </div>
        );
      })
    )
  )
);
